import type { ComponentContentSchema } from '@vibesites/runtime';
import { RichTextContent, useContentToken } from '@vibesites/runtime/react';

function hasValue(val: string | null | undefined): val is string {
  if (!val) return false;
  const normalized = val.trim().toLowerCase();
  return normalized !== '' && normalized !== 'false' && normalized !== 'null' && normalized !== 'undefined';
}

export function PricingVerbiage() {
  const pricingVerbiage = useContentToken('pricingverbiage.text');

  if (!hasValue(pricingVerbiage)) return null;

  return (
    <section className="pt-8 pb-4 md:pt-12 md:pb-6 bg-[var(--vibe-color-background)]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <RichTextContent
          path="pricingverbiage.text"
          as="p"
          className="font-body text-sm sm:text-base leading-relaxed text-[var(--vibe-color-text-muted)]"
        />
      </div>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'PricingVerbiage',
  displayName: 'Pricing Verbiage',
  tokens: {
    'pricingverbiage.text': {
      label: 'Pricing Verbiage',
      type: 'richtext',
      defaultField: 'custom_pricing_verbiage',
    },
  },
};

(PricingVerbiage as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default PricingVerbiage;
